<div class="page-content-container">
  <h1 class="page-header">Pravidla</h1>
  <div class="rules-wrapper">
    <div class="rules-left-container rules-container">
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Na začátek</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Tento program je dynamický. Organizátoři, a jak brzy zjistíš, nejen
            oni, mohou a nemusí měnit pravidla v průběhu.
            Doporučujeme k programu přistupovat vážně a věci nepodceňovat.
            Rozhodně není dobré spoléhat na to, že se o tebe někdo postará.
          </p>
          <p class="card-text">
            Program je dobrovolný, ale pokud se ho odmítneš účastnit,
            nevezmeme tě na akci. Vhodný okamžik pro rozhodnutí je právě
            nyní, po přečtení pravidel a úkolů.
          </p>
          <p class="card-text">
            Každý je sám za sebe, stejně jako v životě. Ovšem, stejně
            jako v životě, se vyplatí mít okolo sebe lidi, na které se
            můžeš spolehnout a kteří ti pomůžou. Ne vždy to musí
            být právě ti, které znáš nejlépe.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>O co jde?</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Jde o tvůj životní čas, o nic víc a o nic míň. Jsi
            ve světě In Time. Čas na tvém účtu se každou sekundou
            zmenšuje. Máš <strong>4,5 hodiny</strong> do začátku. Když nic
            neuděláš, v 10:30 ti čas dojde. Pokud se tak stane, končíš. Nemůžeš
            pokračovat v programu In Time. Nejde jen o In Time, nedostaneš
            se na akci. Proto doteď neznáš místo ani čas odjezdu, pozici
            objektu, ani jakou část z celé akce In Time tvoří. A tak
            to ještě nějakou dobu zůstane. Jedno je ale jisté. Vyplatí
            se počítat s tím, že času potřebuješ dost na <strong>celou
            akci</strong> (včetně spánku). Čas bude možné získávat během celého
            In Time. Někdy ale mohou být období hojnosti a jindy období
            půstu. Doporučujeme si tedy zajistit dost času na spánek
            i na dny, kdy čas získávat nepůjde.
          </p>
          <mat-divider></mat-divider>
          <p class="card-text">
            In Time není jen o čase, je o všem.
            <strong>Je jen na tobě, co se svým časem uděláš.</strong>
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Jak čas získám?</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Čas získáš, když ty nebo tvůj tým splní úkol. Případně, když ti ho
            někdo daruje. Úkoly můžeš najít na stránce
            <span class="router-link" [routerLink]="'/' + routesPaths.Tasks"
              >Úkoly</span
            >. Vždy je definováno, kdo čas získá. A přesně tato
            osoba musí získaný čas do systému přes svůj účet zapsat.
          </p>
          <p class="card-text">
            Úkoly budou v průběhu hry přibývat i mizet (jakmile
            úkol zmizí ze systému, již ho nelze splnit). Počítej
            i s variantou, že se žádné nové úkoly neobjeví mnoho
            hodin.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Jak získaný čas dostanu do systému?</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Po splnění úkolu najedeš na stránku
            <span class="router-link" [routerLink]="'/' + routesPaths.Logs"
              >Logy</span
            >. Vyplníš vše potřebné a odešleš. Zadání získaného času do systému
            zbytečně neodkládej.
          </p>
          <p class="card-text">
            Nemáš-li vlastní mobil s internetem či powerbanku,
            doporučujeme ti dohodnout se s jiným účastníkem, kterému
            věříš a oboje má k dispozici. Této osobě lze svěřit své
            přihlašovací údaje, to zakázané není. Avšak případné
            zneužití je problém vás dvou, v světě In Time hraje
            primárně každý na sebe.
          </p>
          <p class="card-text">
            Proč píšeme o svěření přihlašovacích údajů,
            když můžeš čas jednoduše připsat či darovat někomu
            jinému? Protože když čas připisuješ sobě, dostaneš ho
            jiné množství, než dostane tvůj tým nebo dokonce někdo
            jiný. Stejně tak je to i u daru. Tyto poměry se mohou
            v průběhu hry měnit!
          </p>
          <p class="card-text">
            Doporučujeme sledovat aktuální informace v popisu při
            zadávání. Je to In Time, neočekávej, že tě o změně
            budeme informovat.
          </p>
          <p class="card-text">
            Pokud nemáš přístup k internetu ani žádnou osobu, na
            kterou by ses v dané transakci chtěl spoléhat, je tu nouzová
            možnost. Můžeš poslat organizátorům komunikační SMS. Tvoje
            telefonní číslo musí být nejdříve do „systému“
            přihlášeno. Formát SMS včetně přihlášení do
            „systému“ je definován v části komunikace s organizátory
            pomoci SMS. Organizátoři čas zapíší do systému, až se
            jim to bude hodit. Neočekávej okamžitý zápis těsně před
            vypršením tvého času. Pokud ti mezitím čas dojde, jednoduše
            došel. Takový je svět In Time.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Jak kontrolovat sebe a ostatní?</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Všechny zadané časové transakce můžeš zkontrolovat
            na stránce Logy. Transakce jsou řazeny od nejnovější
            po nejstarší. Pokud se ti něco nebude zdát, klidně od
            ostatních žádej vysvětlení, za co byla daná transakce
            provedena. Stejně tak mohou ostatní toto vysvětlení žádat
            po tobě.
          </p>
          <p class="card-text">
            Chceš-li si vyzkoušet, jak systém funguje, můžeš
            zaznamenat úkol a vyplnit nulu do kolonky času.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title
            >K čemu slouží jednotlivé položky při zadávání času do
            systému?</mat-card-title
          >
        </mat-card-header>
        <mat-card-content>
          <div class="sub-header">Svědek</div>
          <p class="card-text">
            Ten, kdo je schopný dosvědčit, že daný čas připisuješ dle pravidel
            či dohod mezi účastníky In Time (dohody nesmí porušovat pravidla).
            Pokud jsi při plnění úkolu sám, jsi sám sobě svědkem.
          </p>
          <div class="sub-header">Popis</div>
          <p class="card-text">
            Toto pole by mělo vysvětlovat, za co byl čas získán. Zápis by
            měl být stručný, ale hlavně takový, aby byl všem jasný.
          </p></mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title
            >Technický či jiný problém se systémem?</mat-card-title
          >
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Snažíme se, aby vše maximálně fungovalo, pokud se i přesto
            do našeho systému vloudil nějaký šotek, informuj nás prosím
            - viz komunikace s organizátory pomocí SMS. Pokud vzniknou
            nějaké zbytečné škody, budeme se je snažit férově
            napravit. Ovšem ne vždy to jde. Prosíme tedy o shovívavost.
          </p>
          <p class="card-text">
            Pokud nastane technický problém, který znevýhodní všechny
            stejně (tedy je v podstatě spravedlivý), pokusíme se ho
            v rámci možností napravit. Nebudeme ale podnikat žádné
            další akce (např. připisování času jako kompenzaci škod).
          </p>
          <p class="card-text">
            Bude-li se někdo snažit systém technicky obejít (hacknout)
            či jinak záměrně zneužít či využít ve svůj prospěch,
            budou organizátoři nemilosrdní. Toto není součástí
            programu. Prosíme, nedělejte to.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
    </div>
    <!-- RIGHT SIDE CONRTAINER -->
    <div class="rules-right-container rules-container">
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>
            Facebooková skupina
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Facebooková skupina byla zřízena speciálně pro tuto
            akci. Členy jsou všichni účastníci i organizátoři
            a část B-týmu. Nikdo další nemá a nebude mít do skupiny
            přístup. Všichni mohou do skupiny přidávat příspěvky,
            a to z následujících důvodů:
          </p>
          <ul class="card-text">
            <li>
              Splnění zadaného úkolu vyžaduje přidání fotky či
              videa. Není-li to v úkolu specifikováno, lze použít obojí.
            </li>
            <li>
              V některých úkolech lajky ostatních zvýší časový zisk.
            </li>
            <li>
              Další libovolná komunikace.
            </li>
          </ul>
          <p class="card-text">
            Dále je součástí skupiny několik chatů:
          </p>
          <ul class="card-text">
            <li>
              INFORMACE: informační kanál od organizátorů. Sem nepište!
            </li>
            <li>
              PRAVIDLA: slouží ke schvalování pravidel, viz níže.
            </li>
            <li>
              DISKUZE – chat pro komunikaci mezi účastníky (nikoliv pro
            komunikaci s organizátory)
            </li>
          </ul>
          <p class="card-text">
            Je-li kdekoli v textu zmíněn facebook, FB nebo skupina, je
            vždy myšlena výše popsaná facebooková skupina akce.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Tvorba pravidel a úkolů od účastníků</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Kdokoli, kdo je součástí této akce, může navrhnout nebo
            upravit pravidlo nebo úkol.  Pravidlo nebo úkol musí schválit
            nadpoloviční většina účastníků akce a alespoň dva
            organizátoři. Pravidlo se stává platným, jakmile je zavedeno
            do systému.  Úkol se stává platným od okamžiku potvrzení
            organizátory (dodatečně bude zveřejněn i na stránce
            <span class="router-link" [routerLink]="'/' + routesPaths.Tasks">
              Úkoly</span>).
          </p>
          <p class="card-text">
            Navrhované pravidlo či úkol je třeba zapsat do chatu
            PRAVIDLA. „Lajk“ (palec nahoru) znamená schvalující
            hlas. Jiné typy smajlíků prosím nepoužívejte. Je také
            možné, aby pravidlo odsouhlasil hromadně za celý tým jeden
            zástupce, který uvede název týmu a jména těch, kteří
            souhlasí.
          </p>
          <p class="card-text">
            Zároveň platí, že organizátoři mohou kdykoli změnit,
            vytvořit či zrušit libovolné pravidlo či úkol bez souhlasu
            účastníků a bez toho, aby o tom dali vědět. Pokud
            však budeme měnit tato obecná pravidla, slibujeme, že vás
            upozorníme. Není třeba být absolutně paranoidní, jen trochu.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>Komunikace s organizátory pomocí SMS</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Primární telefonní číslo pro komunikaci s organizátory je
            <a href="tel:+420720521694">+420 720 521 694</a> (Dan Farkač),
            záložní
            <a href="tel:+420721932871">+420 721 932 871</a> (Sorondil),
            <a href="tel:+420775893636">+420 775 893 636</a> (Klára Čiháková)
            a pak jakékoli jiné organizátorské (viz Lidé na akci).
          </p>
          <div class="sub-header">Inicializace telefonu</div>
          <p class="card-text">
            Každé telefonní číslo, které chce komunikovat
            s organizátory pomocí SMS, se musí „inicializovat“. Buď
            jako osoba nebo jako komunikační číslo za celý tým.
          </p>
          <p class="card-text">
            Pro tým je třeba vyjmenovat všechny členy. Následuje příklad formátu
            dané inicializační SMS.
          </p>
          <div class="code-block">
            INIT OSOBA [JMENO PREZDIVKA PRIJMENI] <br /><br />
            INIT TYM [JMENO TYMU]; [JMENO PRIJMENI CLENA 1]; [JMENO PRIJMENI
            CLENA 2];...
          </div>
          <p class="card-text">Tedy konkrétně pro jméno Luděk Dvořák</p>
          <div class="code-block">INIT OSOBA LUDEK DVORAK</div>
          <p class="card-text">
            A pro tým Luděk Dvořák, Jiřina Bohdalová, Indra Kocour Mikeš
          </p>
          <div class="code-block">
            INIT TYM LUDEK DVORAK; JIRINA BOHDALOVA; INDRA KOCOUR MIKES
          </div>
          <div class="spacer"></div>
          <div class="sub-header">Zaznamenání času</div>
          <p class="card-text">
            „Nouzové“ zaznamenání času. Prosíme nepoužívat
            zbytečně, povede to k delšímu čekání. A nejlépe
            nepoužívat vůbec.
          </p>
          <div class="code-block">
            LOG [PROME|PROTYM|PRONEKOHO|DAR]; [OSOBA]; [CAS v MINUTACH];
          </div>
          <p class="card-text">Příklad: toto je logování 60 minut</p>
          <div class="code-block">LOG PROME;LUDEK DVORAK;60;</div>
          <div class="spacer"></div>
          <div class="sub-header">Poskytnuti informace</div>
          <p class="card-text">
            Pokud jen chcete poslat nepříliš důležitou informaci
          </p>
          <div class="code-block">INFO [INFORMACE]</div>
          <div class="spacer"></div>
          <div class="sub-header">Varování / výstraha</div>
          <p class="card-text">
            Pokud chcete organizátory před něčím varovat či poskytnout důležité
            varování pro ostatní prostřednictvím organizátorů.
          </p>
          <div class="code-block">WARN [INFORMACE]</div>
          <div class="spacer"></div>
          <div class="sub-header">Poskytnutí vaší polohy</div>
          <p class="card-text">Pokud posíláte svoji polohu.</p>
          <div class="code-block">LOC [OSOBA|TYM] [popis polohy či gps]</div>
          <div class="spacer"></div>
          <div class="sub-header">Report problému</div>
          <p class="card-text">Report technického nebo jiného problému.</p>
          <div class="code-block">ERROR [popis problému]</div>
          <div class="spacer"></div>
          <div class="sub-header">Žádost o pomoc</div>
          <p class="card-text">
            Tuto zprávu doufáme, že vůbec nedostaneme. Pokud půjde opravdu do
            tuhého, samozřejmě rovnou volejte.
          </p>
          <div class="code-block">HELP [popis]</div>
          <p class="card-text">
            Prosím toto používejte opravdu jen při ohrožení.
          </p>
          <div class="spacer"></div>
          <mat-divider></mat-divider>
          <div class="spacer"></div>
          <p class="card-text">
            Všechny kódy mají i varianty s otazníkem. To znamená, že
            se orgové dožadují informace od vás, například informace
            o poloze nebo upřesnění či rozšíření předchozí
            informace.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title class="last-header"
            >PRVNÍ ÚKOL ZA TEBOU</mat-card-title
          >
        </mat-card-header>
        <mat-card-content>
          <p class="card-text">
            Pokud jsi právě poprvé pozorně přečetl či přečetla
            celá tato pravidla, což odhadujeme přibližně na 30 minut
            času, získáváš jednorázově 45 minut. Minuty zapiš do
            systému. Připsáním zároveň potvrzuješ přečtení pravidel.
          </p>
          <p class="card-text">
            Pokud pravidla nebudeš mít s sebou v digitální podobě,
            vytiskni si je nebo si aspoň opiš důležité části.
          </p>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>
    </div>
  </div>
</div>
